import { render, staticRenderFns } from "./SubscriptionServiceItem.vue?vue&type=template&id=65b00201&scoped=true&"
import script from "./SubscriptionServiceItem.vue?vue&type=script&lang=js&"
export * from "./SubscriptionServiceItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b00201",
  null
  
)

export default component.exports